import cmsHeaderSliderBlockObject from '@/entities/cmsHeaderSliderBlock/interface'
import { Col, Container, Row } from 'react-bootstrap'
import SliderWithDots from '@/components/elements/sliders/SliderWithDots'
import { buildSlideData } from '@/components/models/cms/blocks/HeaderSliderBlock/functions'
import cmsHeaderSliderBlockSlideObject from '@/entities/cmsHeaderSliderBlockSlide/interface'
import HeaderSliderTeaser from '@/components/models/cms/blocks/HeaderSliderBlock/HeaderSliderTeaser/HeaderSliderTeaser'
import { useTranslation } from 'next-i18next'
import { useContext } from 'react'
import { CmsContext } from '@/app/providers/CmsProvider'
import { isTravelOnline } from '@/lib/helpers/travel'

const HeaderSliderBlock = ({ slides }: cmsHeaderSliderBlockObject) => {
  const { t } = useTranslation('common')
  const context = useContext(CmsContext)

  if (!context) {
    throw new Error('no CmsProvider found')
  }

  const { getPageUrl } = context

  const getSlides = (slides: cmsHeaderSliderBlockSlideObject[]) => {
    let slideElements: Array<any> = []
    slides
      // filter out slides that are not online
      .filter((slide) => {
        switch (slide.link.type) {
          case 'travel':
            return isTravelOnline(slide.link.travel)
          case 'page':
            return slide.link.page && slide.link.page.onlineStatus !== 'OFFLINE'
        }
      })
      .map((slide, index: number) => {
        slideElements.push(<HeaderSliderTeaser {...buildSlideData(slide, index, t, getPageUrl)} key={index} />)
      })
    return slideElements
  }

  return (
    <>
      <Container fluid>
        <Row>
          <Col className="p-0">
            <SliderWithDots
              slides={getSlides(slides)}
              dotsPosition={'bottom'}
              autoplay={8000}
              ssr={true}
              trackingStringPrefix={'cms_block:header_slider'}
            />
          </Col>
        </Row>
      </Container>
      <style global jsx>
        {`
          main {
            margin-top: 0;
          }
        `}
      </style>
    </>
  )
}

export default HeaderSliderBlock
